import { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  Text,
  TextInput,
  Group,
  Stack,
  NumberInput,
} from "@mantine/core";

import { validatePhoneNumber } from "./helpers/Api";

export default function ContactInformation({
  formData,
  updateFormField,
  isValidEmail,
}) {
  const [phoneError, setPhoneError] = useState(null);

  const handlePhoneBlur = async () => {
    if (
      formData.phone === null ||
      formData.phone === undefined ||
      String(formData.phone).trim() === ""
    ) {
      setPhoneError(null);
      return;
    }

    const isValid = await validatePhoneNumber(formData.phone);

    setPhoneError(isValid ? null : "Please enter a valid phone number");
    updateFormField("phoneIsValid", isValid);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fafafa",
        borderRadius: "8px",
        maxWidth: 600,
        lineHeight: "120%",
      }}
    >
      <Stack spacing="md">
        <Text fw={600} fz="lg">
          Contact Information
        </Text>
        <Group grow>
          <TextInput
            label="First name"
            placeholder="First"
            withAsterisk
            value={formData.firstName}
            onChange={(e) => updateFormField("firstName", e.target.value)}
          />
          <TextInput
            label="Last Name"
            placeholder="Last"
            withAsterisk
            value={formData.lastName}
            onChange={(e) => updateFormField("lastName", e.target.value)}
          />
        </Group>
        <TextInput
          value={formData.email}
          onChange={(e) => updateFormField("email", e.target.value)}
          withAsterisk
          label="Email"
          placeholder="email"
          error={
            formData.email && !isValidEmail
              ? "Please enter a valid email address"
              : null
          }
        />
        <NumberInput
          label="Phone"
          value={formData.phone}
          withAsterisk
          placeholder="Your phone"
          onChange={(value) => updateFormField("phone", value)}
          allowNegative={false}
          hideControls
          onBlur={handlePhoneBlur}
          error={phoneError}
        />
        <TextInput
          value={formData.company}
          onChange={(e) => updateFormField("company", e.target.value)}
          label="Company"
          placeholder="Company"
        />
        <Checkbox
          size="md"
          onChange={(e) =>
            updateFormField("agreeToSms", e.currentTarget.checked)
          }
          label={
            <>
              [Optional] I agree to receive SMS notifications from Busbank, a
              Global Charter Services Company, regarding trip details, followups
              and any clarification need for my itinerary.
              <br />
              <br />
              You will receive up to 2 follow up messages within 7 business days
              after submitting this form. Reply STOP to unsubscribe at any time.
              Please refer to our Privacy Policy to know about how this
              information will be used." variant="outline
            </>
          }
          styles={{
            input: {
              borderColor: "#adb5bd",
              cursor: "pointer",
            },
            label: {
              fontWeight: 400,
              fontSize: "10px",
              color: "#383838",
              lineHeight: "125%",
              cursor: "pointer",
              paddingLeft: "8px",
            },
          }}
        />
      </Stack>
    </Box>
  );
}
